module.exports = __webpack_public_path__ + "img/686E55_353C2F_869B7F_444434-256px.3ad22395.png";